export const COMMENT_EDITOR_KEY_ATTRIBUTE = 'data-comment-editor-key';

export const registerCommentEditorRoot = (rootElement: HTMLElement, editorKey: string): void => {
  rootElement.setAttribute(COMMENT_EDITOR_KEY_ATTRIBUTE, editorKey);
};

export const unregisterCommentEditorRoot = (rootElement: HTMLElement, editorKey: string): void => {
  if (rootElement.getAttribute(COMMENT_EDITOR_KEY_ATTRIBUTE) === editorKey) {
    rootElement.removeAttribute(COMMENT_EDITOR_KEY_ATTRIBUTE);
  }
};

export const getCommentEditorKeyForElement = (element: HTMLElement): string | null =>
  element
    .closest<HTMLElement>(`[${COMMENT_EDITOR_KEY_ATTRIBUTE}]`)
    ?.getAttribute(COMMENT_EDITOR_KEY_ATTRIBUTE) ?? null;
